import { makeStyles } from "@mui/styles";
import { THEME_COLORS } from "../../context/constants";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column" as const,
    minHeight: "80vh",
    fontFamily: "Lexend, sans-serif",
    padding: "32px 40px",
    maxWidth: "1280px",
    margin: "0 auto",
    width: "100%",
    boxSizing: "border-box" as const,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
    gap: "16px",
    flexWrap: "wrap" as const,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  titleIcon: {
    color: THEME_COLORS.yellow,
    fontSize: "32px",
  },
  title: {
    fontSize: "28px !important",
    fontWeight: "600 !important" as any,
    color: "#222",
    fontFamily: "Lexend, sans-serif !important",
  },
  subtitle: {
    fontSize: "14px !important",
    color: "#888 !important",
    fontFamily: "Lexend, sans-serif !important",
    marginBottom: "20px !important",
  },
  createButton: {
    backgroundColor: `${THEME_COLORS.yellow} !important`,
    color: "#000 !important",
    fontFamily: "Lexend, sans-serif !important",
    fontWeight: "600 !important",
    borderRadius: "10px !important",
    padding: "8px 20px !important",
    fontSize: "14px !important",
    textTransform: "none !important" as "none",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: `${THEME_COLORS.darkYellow} !important`,
      boxShadow: "none !important",
    },
    "&:disabled": {
      opacity: "0.5 !important",
    },
  },
  controlsRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap" as const,
    marginBottom: "12px",
  },
  chipsRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap" as const,
  },
  searchBar: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 14px",
    backgroundColor: "#fafafa",
    border: "1px solid #e8e8e8",
    borderRadius: "12px",
    flex: 1,
    minWidth: "240px",
    maxWidth: "360px",
    marginLeft: "auto",
    "&:focus-within": {
      borderColor: THEME_COLORS.yellow,
      backgroundColor: "#fff",
    },
  },
  sourceLine: {
    fontSize: "13px !important",
    color: "#666 !important",
    fontFamily: "Lexend, sans-serif !important",
    marginBottom: "16px !important",
  },
  loadingWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "64px 0",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    padding: "64px 24px",
    backgroundColor: "#fafafa",
    border: "1px dashed #ddd",
    borderRadius: "16px",
    marginTop: "24px",
  },
  emptyIconWrapper: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    backgroundColor: THEME_COLORS.lightYellow3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyIcon: {
    color: THEME_COLORS.yellow,
    fontSize: "36px !important",
  },
  emptyTitle: {
    fontSize: "18px !important",
    fontWeight: "600 !important" as any,
    color: "#444 !important",
    fontFamily: "Lexend, sans-serif !important",
    textAlign: "center" as const,
  },
  emptySubtitle: {
    fontSize: "14px !important",
    color: "#888 !important",
    fontFamily: "Lexend, sans-serif !important",
    textAlign: "center" as const,
    maxWidth: "440px",
  },
  editFab: {
    position: "absolute" as const,
    bottom: 8,
    left: 8,
    zIndex: 9,
    backgroundColor: "rgba(255, 255, 255, 0.95) !important",
    color: "#333 !important",
    width: "32px !important",
    height: "32px !important",
    "&:hover": {
      backgroundColor: `${THEME_COLORS.lightYellow3} !important`,
      color: `${THEME_COLORS.darkYellow} !important`,
    },
  },
}));

export default useStyles;
